import {createImages} from './resources/images';
import {createWorkspaceLogoResources} from './resources/workspaceLogo';

export const createResources = ({resourcePath}) => ({
    IMAGES: {
        ...createImages(resourcePath),
        ...createWorkspaceLogoResources(resourcePath),
    },
});
